import { render, staticRenderFns } from "./CambioEspecialista.vue?vue&type=template&id=2eaaf44a"
import script from "./CambioEspecialista.vue?vue&type=script&lang=js"
export * from "./CambioEspecialista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports